import { Expose } from "class-transformer";
import type { NecessaryDataForProductEnum } from "../../enums/necessary-data-for-product.enum";
import type { ServiceTargetEnum } from "../../enums/service-target.enum";
import type { ServiceTypeEnum } from "../../enums/service-type.enum";
import type { IProductDto } from "./product.dto.interface";

export class ProductDto implements IProductDto {
  @Expose()
  id!: number;
  @Expose()
  target!: ServiceTargetEnum;
  @Expose()
  type!: ServiceTypeEnum;
  @Expose()
  necessaryData!: NecessaryDataForProductEnum[];
  @Expose()
  name!: string;
  @Expose()
  imageUrl!: string;
  @Expose()
  price!: number;
  @Expose()
  freeBlock!: string;
  @Expose()
  description!: string;
  @Expose()
  category!: number;
  @Expose()
  beneficiaries!: string;
  @Expose()
  advantages!: string;
  @Expose()
  duration!: string;
  @Expose()
  requisites!: string;
  @Expose()
  messageFinalized!: string;
  @Expose()
  requiredDocumentsText!: string;
  @Expose()
  issue!: string;
  @Expose()
  shortDescription!: string;
  @Expose()
  certificateDocumentStructureId!: number;
  @Expose()
  applicant!: number;
  @Expose()
  family!: number;
  @Expose()
  member!: number;
  @Expose()
  additionalQuestionnaireName!: string;
  @Expose()
  requisitesQuestionnaireName!: string;
  @Expose()
  requisitesSurveyName!: string | null;
  @Expose()
  familyMemberFieldName!: string;
  @Expose()
  functionNameService!: string;
  @Expose()
  publicationDate!: string;
  @Expose()
  order!: number;
  @Expose()
  unique_identifier!: string;
  @Expose()
  created_at!: Date;
  @Expose()
  updated_at!: Date;
}
